import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Search, Filter, X } from "lucide-react";
import type { DepartmentOption } from "./DocumentsFilters";

interface DocumentLibrariesFiltersProps {
  searchInput: string;
  onSearchInputChange: (value: string) => void;
  departmentId?: string;
  onDepartmentChange: (value: string | undefined) => void;
  departments: DepartmentOption[];
  onClearFilters: () => void;
  hasActiveFilters: boolean;
  departmentLocked?: boolean;
}

const ALL = "ALL";

export function DocumentLibrariesFilters({
  searchInput,
  onSearchInputChange,
  departmentId,
  onDepartmentChange,
  departments,
  onClearFilters,
  hasActiveFilters,
  departmentLocked = false,
}: DocumentLibrariesFiltersProps) {
  const activeDepartment = departments.find((d) => d.id === departmentId);

  return (
    <div className="space-y-4 rounded-lg border border-border bg-card p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Filter className="size-5 text-muted-foreground" />
          <h3 className="font-semibold text-foreground">فلتر المكتبات</h3>
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            className="border-destructive/20 text-destructive hover:bg-destructive/5"
          >
            <X className="w-4 h-4 mr-1" />
            مسح الفلاتر
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="relative">
          <Search className="absolute right-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
          <Input
            placeholder="بحث بالاسم..."
            value={searchInput}
            onChange={(e) => onSearchInputChange(e.target.value)}
            className="pr-10"
          />
        </div>

        <Select
          value={departmentId ?? ALL}
          onValueChange={(v) => onDepartmentChange(v === ALL ? undefined : v)}
          disabled={departmentLocked}
        >
          <SelectTrigger>
            <SelectValue placeholder="الدائرة" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL}>كل الدوائر</SelectItem>
            {departments.map((option) => (
              <SelectItem key={option.id} value={option.id}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2 pt-2 border-t">
          <span className="text-sm font-medium text-muted-foreground">
            الفلاتر النشطة:
          </span>
          {searchInput && <Badge variant="secondary">البحث: {searchInput}</Badge>}
          {activeDepartment && (
            <Badge variant="secondary">الدائرة: {activeDepartment.label}</Badge>
          )}
        </div>
      )}
    </div>
  );
}
